/** Normalize origin + pathname for strict comparison (no trailing slash on pathname except root). */
const getOnlyOriginAndPath = (url: URL): string => {
  const path = url.pathname.replace(/\/+$/, '') || '/';
  return `${url.origin}${path}`;
};

/**
 * Returns true if `redirectUri` matches one of the allowlisted absolute URLs (http/https only).
 */
export function isAllowedRedirectUri(redirectUri: string, allowedUris: readonly string[]): boolean {
  if (!redirectUri || allowedUris.length === 0) {
    return false;
  }

  let parsed: URL;
  try {
    parsed = new URL(redirectUri);
  } catch {
    return false;
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return false;
  }

  if (parsed.username || parsed.password) {
    return false;
  }

  const candidate = getOnlyOriginAndPath(parsed);

  return allowedUris.some((allowed) => {
    try {
      const a = new URL(allowed);
      if (a.protocol !== 'http:' && a.protocol !== 'https:') {
        return false;
      }
      if (a.username || a.password) {
        return false;
      }
      return getOnlyOriginAndPath(a) === candidate;
    } catch {
      return false;
    }
  });
}
